module.exports = __webpack_public_path__ + "static/GavinChing-7a65cbe00043d67e9e11b4618eb1ba2a.jpg";